/**
 * Utilitário para gerenciar notificações nativas do navegador
 */

/**
 * Verifica se o navegador suporta notificações
 */
export function isNotificationSupported() {
  return 'Notification' in window;
}

/**
 * Solicita permissão para enviar notificações
 */
export async function requestNotificationPermission() {
  if (!isNotificationSupported()) {
    console.warn('❌ Notificações não suportadas');
    return false;
  }

  if (Notification.permission === 'granted') {
    return true;
  }

  if (Notification.permission === 'denied') {
    return false;
  }

  try {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  } catch (error) {
    console.error('Erro ao solicitar permissão:', error);
    return false;
  }
}

/**
 * Exibe uma notificação nativa do navegador
 */
export async function showNativeNotification({ title, sender, message, chatId }) {
  // Verifica suporte
  if (!isNotificationSupported()) {
    return null;
  }

  // Verifica permissão
  if (Notification.permission !== 'granted') {
    const granted = await requestNotificationPermission();
    if (!granted) {
      return null;
    }
  }

  try {
    const notificationBody = `${sender}: ${message}`;

    const notification = new Notification(title, {
      body: notificationBody,
      icon: '/logo/logo_single.png',
      tag: chatId,
      requireInteraction: false, // false ele some depois de uns segundos true ele fica na tela ate clicar ou fechar
      silent: false,
    });
    
    notification.onclick = (event) => {
      event.preventDefault();

      // Foca na janela/aba
      window.focus();

      // Navega para o chat usando a URL completa (sem hash)
      window.location.href = `/dashboard/chat/${chatId}`;

      notification.close();
    };

    return notification;
  } catch (error) {
    console.error('Erro ao exibir notificação:', error);
    return null;
  }
}

/**
 * Registra o Service Worker para notificações em segundo plano
 */
export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    console.warn('Service Workers não são suportados neste navegador');
    return null;
  }

  try {
    const registration = await navigator.serviceWorker.register('/service-worker.js', {
      scope: '/',
    });

    console.log('Service Worker registrado com sucesso:', registration);
    return registration;
  } catch (error) {
    console.error('Erro ao registrar Service Worker:', error);
    return null;
  }
}
